import { render, staticRenderFns } from "./ProfessionalPortraitCard.vue?vue&type=template&id=70fecf99&scoped=true"
import script from "./ProfessionalPortraitCard.vue?vue&type=script&lang=js"
export * from "./ProfessionalPortraitCard.vue?vue&type=script&lang=js"
import style0 from "./ProfessionalPortraitCard.vue?vue&type=style&index=0&id=70fecf99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fecf99",
  null
  
)

export default component.exports